import { Badge } from '@radix-ui/themes';
import { t } from 'i18next';
import { MIN_ON_DEMAND_SHOTS } from 'lib_ts/enums/ellipses';
import { OnDemandStatus } from 'lib_ts/enums/on-demand.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IOnDemandMachineState } from 'lib_ts/interfaces/on-demand/i-machine-state';
import { useMemo } from 'react';

// if we have more than this many shot IDs found, the badge will only show "X+ SHOTS" instead
const MAX_SHOTS_DISPLAY = 30;

// null is the default until the ellipse has been fetched at least once
export const PitchOnDemandBadge = (props: {
  odms: IOnDemandMachineState | undefined;
}) => {
  const length = props.odms?.shotIDs.length ?? 0;

  const color = useMemo(() => {
    switch (props.odms?.status) {
      case OnDemandStatus.Ready: {
        if (length < MIN_ON_DEMAND_SHOTS) {
          return RADIX.COLOR.NEUTRAL;
        }

        return RADIX.COLOR.ACCENT;
      }
      case OnDemandStatus.Warning: {
        return RADIX.COLOR.WARNING;
      }
      default: {
        return RADIX.COLOR.DANGER;
      }
    }
  }, [props.odms?.status, length]);

  const label = useMemo(() => {
    const isAllowed = props.odms?.status
      ? [OnDemandStatus.Ready, OnDemandStatus.Warning].includes(
          props.odms.status
        )
      : false;

    if (!isAllowed) {
      return 'Not Available';
    }

    switch (props.odms?.status) {
      case OnDemandStatus.Ready:
      case OnDemandStatus.Warning: {
        if (length === 1) {
          return `1 ${t('common.shot')}`;
        }

        if (length > MAX_SHOTS_DISPLAY) {
          return `${MAX_SHOTS_DISPLAY}+ ${t('common.shots')}`;
        }

        return `${length} ${t('common.shots')}`;
      }

      default: {
        return 'Not Available';
      }
    }
  }, [props.odms?.status, props.odms?.shotIDs, length]);

  return <Badge color={color}>{label}</Badge>;
};
